module.exports = __webpack_public_path__ + "media/icons/check-off-4532f2b9.png";